import { FC } from "react";
import { ResponsiveBar } from "@nivo/bar";
import lodash from "lodash";

const MyResponsiveBar: FC<{
    data: any;
    fromDate: string;
    toDate: string;
    xLabel?: string;
    yLabel?: string;
    keys?: any[]
    indexBy?: string
}> = ({ data, fromDate, toDate, xLabel, yLabel, indexBy, keys }) => (
    <ResponsiveBar
        data={data}
        keys={lodash.map(keys, "accessor")}
        margin={{ top: 40, right: 50, bottom: 110, left: 60 }}
        indexBy={indexBy || "label"}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            // orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 90,
            legend: xLabel ?? "dates",
            legendOffset: 80,
            legendPosition: "middle",
        }}
        axisLeft={{
            // orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: yLabel ?? "counts",
            legendOffset: -40,
            legendPosition: "middle",
        }}
        colors={lodash.map(keys, "color")}
    />
);

export default MyResponsiveBar;
